import { Timeline } from '@powerportalspro/react-fluent';

export function TimelineOptionsSample() {
  return <Timeline tables={['annotation']} pageSize={2} allowSearch={false} maxHeight="360px" />;
}
